module.exports = __webpack_public_path__ + "img/Boot - Sedan.29c16fb8.svg";